export default "__VITE_ASSET__sMFBdU98uA5J8YzXkdYieg__"